import {IContentTierButton} from '@dazn/lp-web/src/types/common.types';
import {getImage, navigateToDifferentChapterUrl} from '@dazn/lp-web/src/utils';

export function transformContentTierButton(response: any): IContentTierButton {
    if (!response) return {} as IContentTierButton;

    const button = response.fields as IContentTierButton;

    button.buttonImage = getImage(button.buttonImage);
    button.action = (
        planSelectorShown,
        billingPlan,
        preselectBillingPeriod
    ) => {
        const chapterData = {
            ...(button.entitlementSetId
                ? {entitlementSetId: button.entitlementSetId}
                : {}),
            ...(planSelectorShown && preselectBillingPeriod
                ? {billingPeriod: billingPlan}
                : button.billingPeriod
                ? {billingPeriod: button.billingPeriod}
                : {}),
            ...(button.isFreemium ? {isFreemium: button.isFreemium} : {}),
            ...(button.promoCode ? {promoCode: button.promoCode} : {})
        };
        navigateToDifferentChapterUrl({
            chapterName: button.chapterName,
            chapterPath: button.buttonHref,
            chapterData
        });
    };

    return button;
}
